/**
 * Obtém um objeto do sessionStorage
 * @param {string} key - Chave do item a ser recuperado
 * @returns {object|null} Objeto recuperado ou null se não existir ou ocorrer erro
 */
export const getObjectFromSession = (key) => {
  if (typeof key !== 'string') {
    return null;
  }

  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (e) {
    return null;
  }
};

/**
 * Armazena um objeto no sessionStorage
 * @param {string} key - Chave para armazenamento
 * @param {object} value - Valor a ser armazenado
 * @returns {object|null} O valor armazenado ou null em caso de erro
 */
export const setObjectToSession = (key, value) => {
  if (typeof key !== 'string') {
    return null;
  }

  if (value === undefined) {
    return null;
  }

  try {
    sessionStorage.setItem(key, JSON.stringify(value));
    return value;
  } catch (e) {
    return null;
  }
};

export const getCurrentStorageName = (prefix, idCurrentEntidade, idCurrentUser) => {
  if (!idCurrentEntidade || !idCurrentUser) {
    return null;
  }

  return `${prefix}_${idCurrentUser}_${idCurrentEntidade}`;
};

export default {
  getObjectFromSession,
  getCurrentStorageName,
  setObjectToSession,
};
